import './App.scss';
import Header from './components/Header';
import Content from './components/Content';

const isMobile = window.innerWidth <= 600;

function App() {
  return (
    <div className="site-container">
      <Header isMobile={isMobile} />
      <Content isMobile={isMobile} />
    </div>
  );
}

export default App;
